import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthFacade } from '../+store/auth/auth.facade';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authFacade: AuthFacade,
    private notification: NzNotificationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.error('[ErrorInterceptor] ', '\n:: ', request, '\n:: ', err);
          switch (err.status) {
            case 401:
              this.authFacade.logOut();
              break;
            default:
              err = err.error || err;
          }
        }
        return throwError(() => err);
      })
    );
  }
}
